export default __webpack_public_path__ + "static/media/Start_Language-EN-1.f2eae0e3.png";